"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../../commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('../../../../../../../config/store');
var helpers = require('../../../checkout/helpers');
var _require2 = require('../../../../../../../config/constants'),
  PAYPAL = _require2.PAYPAL;
var _require3 = require('../../initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var Paypal = /*#__PURE__*/function () {
  function Paypal(config, applicationInfo, adyenTranslations) {
    _classCallCheck(this, Paypal);
    var _window = window,
      paypalReviewPageEnabled = _window.paypalReviewPageEnabled,
      returnURL = _window.returnURL,
      basketAmount = _window.basketAmount,
      makeExpressPaymentsCall = _window.makeExpressPaymentsCall,
      saveShopperData = _window.saveShopperData,
      makeExpressPaymentDetailsCall = _window.makeExpressPaymentDetailsCall,
      showConfirmationAction = _window.showConfirmationAction,
      shippingMethodsUrl = _window.shippingMethodsUrl,
      selectShippingMethodUrl = _window.selectShippingMethodUrl,
      saveExpressPaymentDataUrl = _window.saveExpressPaymentDataUrl;
    this.store = store;
    this.helpers = helpers;
    this.returnUrl = returnURL;
    this.amount = JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.userAction = paypalReviewPageEnabled ? 'continue' : null;
    this.makeExpressPaymentsCallUrl = makeExpressPaymentsCall;
    this.saveShopperDataUrl = saveShopperData;
    this.makeExpressPaymentDetailsCallUrl = makeExpressPaymentDetailsCall;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.saveExpressPaymentDataUrl = saveExpressPaymentDataUrl;
    this.applicationInfo = applicationInfo;
    this.translations = adyenTranslations;
    this.config = config;
  }
  return _createClass(Paypal, [{
    key: "callPaymentFromComponent",
    value: function () {
      var _callPaymentFromComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(state, component) {
        var response, action, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return httpClient({
                method: 'POST',
                url: this.makeExpressPaymentsCallUrl,
                data: {
                  data: JSON.stringify(state.data)
                }
              });
            case 1:
              response = _context.v;
              action = response.fullResponse.action;
              if (action) {
                component.handleAction(action);
              } else {
                component.handleError();
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              component.handleError(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function callPaymentFromComponent(_x, _x2) {
        return _callPaymentFromComponent.apply(this, arguments);
      }
      return callPaymentFromComponent;
    }()
  }, {
    key: "onAuthorized",
    value: function () {
      var _onAuthorized = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data, actions) {
        var _payer$phone, _payer$phone$phone_nu, _payer$name, _payer$name2, _data$authorizedEvent, payer, billingAddress, deliveryAddress, shopperDetails, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _data$authorizedEvent = data.authorizedEvent.payer, payer = _data$authorizedEvent === void 0 ? {} : _data$authorizedEvent, billingAddress = data.billingAddress, deliveryAddress = data.deliveryAddress;
              shopperDetails = {
                shopperEmail: payer.email_address,
                telephoneNumber: (_payer$phone = payer.phone) === null || _payer$phone === void 0 ? void 0 : (_payer$phone$phone_nu = _payer$phone.phone_number) === null || _payer$phone$phone_nu === void 0 ? void 0 : _payer$phone$phone_nu.national_number,
                shopperName: {
                  firstName: (_payer$name = payer.name) === null || _payer$name === void 0 ? void 0 : _payer$name.given_name,
                  lastName: (_payer$name2 = payer.name) === null || _payer$name2 === void 0 ? void 0 : _payer$name2.surname
                },
                shippingAddress: deliveryAddress,
                billingAddress: billingAddress
              };
              _context2.n = 1;
              return httpClient({
                method: 'POST',
                url: this.saveShopperDataUrl,
                data: {
                  data: JSON.stringify(shopperDetails)
                }
              });
            case 1:
              actions.resolve();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              $.spinner().stop();
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function onAuthorized(_x3, _x4) {
        return _onAuthorized.apply(this, arguments);
      }
      return onAuthorized;
    }()
  }, {
    key: "makeExpressPaymentDetailsCall",
    value: function () {
      var _makeExpressPaymentDetailsCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
        var response, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return httpClient({
                method: 'POST',
                url: this.makeExpressPaymentDetailsCallUrl,
                data: {
                  data: JSON.stringify({
                    data: data
                  })
                }
              });
            case 1:
              response = _context3.v;
              this.helpers.createShowConfirmationForm(this.showConfirmationAction);
              this.helpers.setOrderFormData(response);
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              $.spinner().stop();
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function makeExpressPaymentDetailsCall(_x5) {
        return _makeExpressPaymentDetailsCall.apply(this, arguments);
      }
      return makeExpressPaymentDetailsCall;
    }()
  }, {
    key: "onShippingAddressChange",
    value: function () {
      var _onShippingAddressChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data, actions, component) {
        var shippingAddress, currentPaymentData, requestBody, response, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              shippingAddress = data.shippingAddress;
              currentPaymentData = component.paymentData;
              if (shippingAddress) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, actions.reject());
            case 1:
              requestBody = {
                paymentMethodType: PAYPAL,
                currentPaymentData: currentPaymentData,
                address: {
                  city: shippingAddress.city,
                  country: shippingAddress.country,
                  countryCode: shippingAddress.countryCode,
                  stateCode: shippingAddress.state,
                  postalCode: shippingAddress.postalCode
                }
              };
              _context4.n = 2;
              return httpClient({
                method: 'POST',
                url: this.shippingMethodsUrl,
                data: {
                  data: JSON.stringify(requestBody)
                }
              });
            case 2:
              response = _context4.v;
              Paypal.updateComponent(response, component);
              return _context4.a(2, null);
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              return _context4.a(2, actions.reject(data.errors.ADDRESS_ERROR));
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function onShippingAddressChange(_x6, _x7, _x8) {
        return _onShippingAddressChange.apply(this, arguments);
      }
      return onShippingAddressChange;
    }()
  }, {
    key: "onShippingOptionsChange",
    value: function () {
      var _onShippingOptionsChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data, actions, component) {
        var selectedShippingOption, response, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              selectedShippingOption = data.selectedShippingOption;
              if (selectedShippingOption) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, actions.reject());
            case 1:
              _context5.n = 2;
              return httpClient({
                method: 'POST',
                url: this.selectShippingMethodUrl,
                data: {
                  data: JSON.stringify({
                    paymentMethodType: PAYPAL,
                    currentPaymentData: component.paymentData,
                    methodID: selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.id
                  })
                }
              });
            case 2:
              response = _context5.v;
              Paypal.updateComponent(response, component);
              return _context5.a(2, null);
            case 3:
              _context5.p = 3;
              _t5 = _context5.v;
              return _context5.a(2, actions.reject(data.errors.METHOD_UNAVAILABLE));
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function onShippingOptionsChange(_x9, _x0, _x1) {
        return _onShippingOptionsChange.apply(this, arguments);
      }
      return onShippingOptionsChange;
    }()
  }, {
    key: "onAdditionalDetails",
    value: function () {
      var _onAdditionalDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(state, component) {
        var response, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              if (!this.userAction) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return httpClient({
                method: 'POST',
                url: this.saveExpressPaymentDataUrl,
                data: {
                  data: JSON.stringify(state.data)
                }
              });
            case 1:
              response = _context6.v;
              if (response.success && response.redirectUrl) {
                window.location.href = response.redirectUrl;
              }
              _context6.n = 4;
              break;
            case 2:
              _context6.n = 3;
              return this.makeExpressPaymentDetailsCall(state.data);
            case 3:
              document.querySelector('#additionalDetailsHidden').value = JSON.stringify(state.data);
              document.querySelector('#showConfirmationForm').submit();
            case 4:
              _context6.n = 6;
              break;
            case 5:
              _context6.p = 5;
              _t6 = _context6.v;
              component.handleError(_t6);
              $.spinner().stop();
            case 6:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 5]]);
      }));
      function onAdditionalDetails(_x10, _x11) {
        return _onAdditionalDetails.apply(this, arguments);
      }
      return onAdditionalDetails;
    }()
  }, {
    key: "getConfig",
    value: function getConfig() {
      return _objectSpread(_objectSpread({
        configuration: this.config,
        showPayButton: this.showPayButton,
        returnUrl: this.returnUrl,
        amount: this.amount,
        isExpress: this.isExpress
      }, this.userAction ? {
        userAction: this.userAction
      } : {}), {}, {
        onSubmit: this.callPaymentFromComponent.bind(this),
        onError: Paypal.onError,
        onAuthorized: this.onAuthorized.bind(this),
        onAdditionalDetails: this.onAdditionalDetails.bind(this),
        onShippingAddressChange: this.onShippingAddressChange.bind(this),
        onShippingOptionsChange: this.onShippingOptionsChange.bind(this),
        blockPayPalCreditButton: true,
        blockPayPalPayLaterButton: true,
        blockPayPalVenmoButton: (typeof window !== 'undefined' && window.blockPayPalVenmoButton !== undefined) ? window.blockPayPalVenmoButton : true
      });
    }
  }, {
    key: "getComponent",
    value: function () {
      var _getComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var checkout, paypalConfig;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return initializeCheckout(this.applicationInfo, this.translations);
            case 1:
              checkout = _context7.v;
              paypalConfig = this.getConfig();
              return _context7.a(2, window.AdyenWeb.createComponent(PAYPAL, checkout, paypalConfig));
          }
        }, _callee7, this);
      }));
      function getComponent() {
        return _getComponent.apply(this, arguments);
      }
      return getComponent;
    }()
  }], [{
    key: "updateComponent",
    value: function updateComponent(response, component) {
      if (response) {
        var paymentData = response.paymentData,
          status = response.status,
          _response$errorMessag = response.errorMessage,
          errorMessage = _response$errorMessag === void 0 ? '' : _response$errorMessag;
        if (!paymentData || status !== 'success') {
          throw new Error(errorMessage);
        }
        // Update the Component paymentData value with the new one.
        component.updatePaymentData(paymentData);
      } else {
        var _response$errorMessag2 = response.errorMessage,
          _errorMessage = _response$errorMessag2 === void 0 ? '' : _response$errorMessag2;
        throw new Error(_errorMessage);
      }
      return false;
    }
  }, {
    key: "onError",
    value: function onError() {
      $.spinner().stop();
    }
  }]);
}();
module.exports = Paypal;